import { Instance, SnapshotOut, types } from "mobx-state-tree"
import { BaseModelStoreProps } from "../base-model-store/base-model-store"

const QuizStoreProps = {
  ...BaseModelStoreProps,

  questions: types.optional(types.array(types.frozen()), []),
  answers: types.optional(types.array(types.frozen()), []),
  times: types.optional(types.array(types.frozen()), []),

}


/**
 * Model description here for TypeScript hints.
 */
export const QuizStoreModel = types
  .model("QuizStore")
  .props(QuizStoreProps)
  .views((self) => ({})) // eslint-disable-line @typescript-eslint/no-unused-vars
  .actions((self) => ({
    set(key: keyof typeof QuizStoreProps, value: any) {
      if (self[key] === value) return
      self[key] = value as never;
    },
  })) // eslint-disable-line @typescript-eslint/no-unused-vars

type QuizStoreType = Instance<typeof QuizStoreModel>
export interface QuizStore extends QuizStoreType {}
type QuizStoreSnapshotType = SnapshotOut<typeof QuizStoreModel>
export interface QuizStoreSnapshot extends QuizStoreSnapshotType {}
export const createQuizStoreDefaultModel = () => types.optional(QuizStoreModel, {})
